import {
  FIELD_DESCRIPTION_KEY,
  FIELD_NAME_KEY
} from "PFApp/constants/activity_form/activity_form_field_keys";

const MANAGE_ROLES_FIELD_QA_IDS: Record<string, string> = {
  [FIELD_NAME_KEY]: "ManageRoles.RoleRow.NameInput",
  [FIELD_DESCRIPTION_KEY]: "ManageRoles.RoleRow.DescriptionInput"
};

export const getManageRolesFieldQaId = (fieldName: string) => MANAGE_ROLES_FIELD_QA_IDS[fieldName];
